
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { FileText } from 'lucide-react';

interface NoResultsProps {
  errorMessage?: string | null;
}

const NoResults = ({ errorMessage }: NoResultsProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex-grow flex items-center justify-center p-4 my-8">
      <Card className="w-full max-w-lg shadow-lg">
        <CardContent className="p-8 text-center">
          <div className="text-red-500 mb-4">
            <FileText className="h-16 w-16 mx-auto" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">No Results Available</h2>
          <p className="text-gray-600 mb-6">
            {errorMessage || "You haven't completed any assessments yet. Take the assessment to receive your personalized career guidance."}
          </p>
          <Button 
            onClick={() => navigate('/assessment')}
            className="bg-brand-blue hover:bg-brand-blue/90"
          >
            Take Assessment
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default NoResults;
